module.exports = __webpack_public_path__ + "img/ltMuonvihySF5KWmerf8rQ7pI00.bb978b74.png";